import { sendUserData } from '@/js/helpers/email-modal'
import { validateForm } from '@/js/helpers/validate-modal'
import { closePopup, showPopup } from '@/js/section/popup'
import { CustomSelect } from '@/js/vendors/custom-slect'

const openDownloadLink = (element: Element): void => {
  const downloadLink = element.getAttribute('data-download')
  if (downloadLink) {
    window.open(downloadLink, '_blank')
  }
}

const initEmailWorksheetsPopup = (selector: string, additionalSelectors?: string[]): void => {
  let selectedElement: Element | null = null
  const isTutor = localStorage.getItem('isTutor')
  const closePopupBtn = document.getElementById('close-email-popup')
  const emailPopup = document.getElementById('email-popup')
  const popupOverlay = document.getElementById('email-popup-overlay')
  const openButton = document.querySelectorAll(selector)
  const additionalOpenButtons: NodeListOf<Element>[] = []
  const downloadButton = document.getElementById('email-result')
  const gradeField = document.querySelector('.grade-field')
  const selectGrade = new CustomSelect('.grade-field')

  if (additionalSelectors && Array.isArray(additionalSelectors)) {
    additionalSelectors.forEach(additionalSelector => {
      const buttons = document.querySelectorAll(additionalSelector)
      if (buttons.length > 0) {
        additionalOpenButtons.push(buttons)
      }
    })
  }

  if (gradeField) {
    const selectButton = gradeField.querySelector('.select__toggle')
    if (!selectButton) return
    selectButton.classList.add('form-field-input')
  }

  if (openButton) {
    openButton.forEach((element) => {
      element.addEventListener('click', () => {
        selectedElement = element
        if (isTutor) {
          openDownloadLink(selectedElement)
        } else {
          showPopup(emailPopup)
        }
      })
    })
  }

  if (additionalOpenButtons.length > 0) {
    additionalOpenButtons.forEach(buttonList => {
      buttonList.forEach((element) => {
        element.addEventListener('click', () => {
          if (openButton && openButton[0]) {
            selectedElement = openButton[0]
          }
          if (isTutor && selectedElement) {
            openDownloadLink(selectedElement)
          } else {
            showPopup(emailPopup)
          }
        })
      })
    })
  }

  if (downloadButton && openButton) {
    downloadButton.addEventListener('click', () => {
      let downloadUrl: string | null = null
      if (selectedElement) {
        downloadUrl = selectedElement.getAttribute('data-download')
      }
      const isValid = validateForm()
      if (!isValid) return
      sendUserData()
      closePopup(emailPopup)
      if (downloadUrl) {
        window.open(downloadUrl, '_blank')
      }
    })
  }

  if (closePopupBtn && emailPopup) {
    closePopupBtn.addEventListener('click', () => {
      closePopup(emailPopup)
    })
  }

  if (popupOverlay) {
    const child = popupOverlay.firstElementChild

    if (child) {
      child.addEventListener('click', function (e) {
        e.stopPropagation()
      })
    }

    popupOverlay.addEventListener('click', () => {
      closePopup(emailPopup)
    })
  }
}

export default initEmailWorksheetsPopup
